import React from "react";
import styled from "styled-components";
import { ButtonStyle } from "../../assets/css/components/ButtonStyle";

const ButtonAuth = ({ className, children, onSubmit, ...rest }) => {
  return (
    <ButtonStyle className={className} onSubmit={onSubmit} {...rest}>
      {children}
    </ButtonStyle>
  );
};

export default styled(ButtonAuth)`
  width: 95%;
  padding: 15px 0;
  background-color: #489D96;
`;
